import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ReuseService implements RouteReuseStrategy {

  private storedRoutes = new Map<string, DetachedRouteHandle>();

  shouldReuseRoute(future: ActivatedRouteSnapshot, current: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === current.routeConfig && JSON.stringify(future.params) === JSON.stringify(current.params);
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    if (route.data['reuse']) { // 如果路由被标记为需要缓存
      this.storedRoutes.set(route.routeConfig?.path || '', handle);
    }
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return this.storedRoutes.get(route.routeConfig?.path || '') || null;
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    if(route.routeConfig?.path?.includes('order/history') ){
      return !!route.routeConfig && !!this.storedRoutes.has(route.routeConfig.path || '') && localStorage.getItem('isOrderDetailBack')==="true";
    }else if(route.routeConfig?.path?.includes('ecatalog') ){
      return !!route.routeConfig && !!this.storedRoutes.has(route.routeConfig.path || '') && localStorage.getItem('isProductDetailBack')==="true";
    }else{
      return !!route.routeConfig && !!this.storedRoutes.has(route.routeConfig.path || '');
  }
    }


  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return !!route.routeConfig && !!route.data['reuse'];
  }

  detach(route: ActivatedRouteSnapshot): DetachedRouteHandle | undefined {
    if (!route.routeConfig || !this.storedRoutes.has(route.routeConfig.path || '')) {
      return undefined;
    }
    const handle = this.storedRoutes.get(route.routeConfig.path || '');
    this.storedRoutes.delete(route.routeConfig.path || '');
    return handle;
  }
}
